import React, { useState } from "react";
import { MEDIA_URL } from "../../config/url";
import { useNavigate } from "react-router-dom";
import { Modal } from "@mui/material";
import Event2 from "../../assets/img/events/event2.png";

export const EventCategory = ({ eventtypetable }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div class="langMenu__content bg-white rounded-8 px-40 py-40 lg:px-20 lg:py-20">
          <div class="px-10 py-10 sm:px-15 sm:py-15 text-center">
            <p className="text-primary fw-600 text-18">We are getting ready.</p>
            <p className="text-13 fw-500 mb-20">
              In the meanwhile, please contact to list your event.
            </p>
            <p className="text-12 fw-500">marketing@fitizenindia.com</p>
            <p className="text-12 fw-500">supportevents@fitizenindia.com</p>
          </div>
        </div>
      </Modal>
      <section className="layout-pt-sm layout-pb-md bg-light-4">
        <div className="container">
          <div className="row y-gap-30 pt-40">
            <div className="col-xl-6 col-lg-6">
              <div className="row">
                {eventtypetable?.map((rowdata) => {
                  return (
                    <div
                      className="w-1/2 lg:w-1/2 sm:w-1/2 mb-20"
                      key={rowdata?.EventType_Id}
                      onClick={() => {
                        localStorage.setItem(
                          "navigateSelectedCategory",
                          rowdata?.EventType_Name
                        );
                        navigate("event/list");
                      }}
                    >
                      <div className="citiesCard -type-2 ">
                        <div className="citiesCard__image rounded-8 ratio ratio-2:1">
                          <img
                            className="img-ratio rounded-4 js-lazy"
                            data-src={`${MEDIA_URL}${rowdata?.Image_Path}`}
                            src={`${MEDIA_URL}${rowdata?.Image_Path}`}
                            alt="category"
                          />
                        </div>
                        <div className="citiesCard__content d-flex items-center justify-center">
                          <div>
                            <h4 className="text-20 lh-13 fw-600 text-white uppercase citiesCard__content-header">
                              {rowdata?.EventType_Name}
                            </h4>
                            <p className="fw-500 text-12 text-white cityCount text-center">
                              {rowdata?.Events_Count} EVENTS
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="col-xl-6 col-lg-6">
              <div className="testimonials -type-2 text-center d-flex justify-center items-center flex-column h-full">
                <div className="sectionTitle -md">
                  <h2 className="sectionTitle__title text-center text-primary text-40 fw-700 lh-12">
                    JOIN <br /> THE MARATHON
                  </h2>
                </div>
                <div className="quote-text text-20 md:text-16 fw-600 text-dark-1 lh-14 mt-10 font-inter">
                  Feel The Thrill Of The Race, Push Your Limits, And Become Part
                  Of A Community Of Champions.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-bg layout-pt-md layout-pb-sm">
        <div className="container">
          <div
            // data-anim="fade delay-1"
            className="section-bg__item"
            data-parallax="0.7"
          >
            <div className="rounded-22 overflow-hidden">
              <img src={Event2} alt="image-event" />
            </div>
            <div
              //   data-anim="fade delay-3"
              className="ctaCard row items-end px-30 lg:py-30 py-60 absolute top-0 bottom-0 lg:pl-10"
            >
              <div className="col-lg-4">
                <h2 className="text-30 lg:text-22 text-white fw-700">
                  Are you an organizer?
                </h2>
                <div className="text-white mt-15 text-14 lg:text-12 lh-14 font-inter">
                  Looking to host your event with us... great! get more reach by
                  enrolling to our platform. list An Event!
                </div>
                <div className="d-inline-block mt-20">
                  <button
                    onClick={() => {
                      handleOpen();
                    }}
                    className="button -grey-1 bg-primary text-white rounded-25 py-15 lg:py-10 lg:px-15 px-60"
                  >
                    List an event!
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default EventCategory;
